import { Action } from '@/core/databus/IMessage'
import { i18n } from '@/i18n'

const { t } = i18n.global

export const useNoticeActionButton = () => {
  const getDefaultButtonLabel = (action: Action) => {
    switch (action) {
      case Action.NAV_TO:
        return t('owork_base.notice_message.notice_button_open')
      case Action.GUIDE_DEVICE_ADDING:
        return t('owork_base.notice_message.notice_button_device_adding')
      case Action.CONTENT_PROMPT:
        return t('owork_base.notice_message.notice_button_content_prompt')
      case Action.LAN_PROMPT:
        return t('owork_base.notice_message.notice_button_lan_prompt')
      default:
        return t('owork_base.check')
    }
  }

  return {
    getDefaultButtonLabel,
  }
}
